import { graphPalettes } from '@styles/themes';

export const useGraphColors = () => {
  return graphPalettes;
};
